import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail,
    CLEAR as clr,
  } from '../../actions/deployments/usage';
  
  const initialState = {
    data: null,
    loading: false,
    error: null
  };
  
  export const reducer = (state = initialState, action) => {
    switch (action.type) {
      case req:
        return {
          ...state,
          loading: true,
          error: null
        };
      case res:
        return {
          ...state,
          loading: false,
          data: action.payload
        };
      case fail:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      case clr:
        return {
          ...state,
          data: null,
          loading: false,
          error: null
        };
      default:
        return state;
    }
  };
